import React, { useState, useEffect } from 'react';

function LastUpdated({ lang }) {
    const [currentTime, setCurrentTime] = useState('');
    const [isoDate, setIsoDate] = useState('');

    useEffect(() => {
        // Define the fixed date
        const lastUpdatedDate = new Date('2024-09-14T00:00:00Z');

        // Format the date
        const formattedDate = lastUpdatedDate.toLocaleDateString(lang, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });

        // Update the state
        setCurrentTime(formattedDate);
        setIsoDate(lastUpdatedDate.toISOString().split('T')[0]);
    }, [lang]); // Dependency array to update when `lang` changes

    // Define labels for different languages
    const labels = {
        en: 'Last Update:',
        ar: 'تاريخ آخر تحديث:',
        de: 'Letzte Aktualisierung:',
        sv: 'Senaste uppdatering:',
        es: 'Última actualización:',
        fr: 'Dernière mise à jour:',
        it: 'Ultimo aggiornamento:',
        pt: 'Última atualização:',
        nl: 'Laatste update:',
        pl: 'Ostatnia aktualizacja:',
        ro: 'Ultima actualizare:',
        ur: 'آخری تازہ کاری:',
        bn: 'সর্বশেষ আপডেট:',
        id: 'Pembaruan terakhir:',
        zh: '最后更新：',
        ru: 'Последнее обновление:'

    };

    // Get the appropriate label based on the lang prop
    const label = labels[lang] || labels['en']; // Default to English if lang is not found

    return (
        <span>
            <b>
                {label}
                <time dateTime={isoDate}>
                    &nbsp;{currentTime}
                </time>
            </b>
        </span>
    );
}

export default LastUpdated;
